"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _index = require("./state/index.js");
var _index2 = require("./templates/index.js");
var _index3 = require("./pipelines/index.js");
var _index4 = require("./helpers/index.js");
var _index5 = require("./utils/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var alloyAnalytics = {
  config: function config(settings) {
    _index.settingsState.init(settings);
  },
  event: function event(type) {
    _index.eventState.addType(type);
    this.webPageDetails();
    this.webInteraction(type);
    this.commerce(type);
    return this;
  },
  webPageDetails: function webPageDetails(data) {
    var _settingsState$defaul;
    var eventType = _index.eventState.data.type;
    var defaultValues = (_settingsState$defaul = _index.settingsState.defaultValues) === null || _settingsState$defaul === void 0 ? void 0 : _settingsState$defaul.webPageDetails;
    var values = data ? _objectSpread(_objectSpread({}, defaultValues), data) : defaultValues;
    var template = (0, _index2.getWebPageDetailsTemplate)(eventType, values);
    if (template) _index.eventState.data.webPageDetails = template;
    return this;
  },
  webInteraction: function webInteraction(eventTypeOrData, data) {
    var isEventType = typeof eventTypeOrData === 'string';
    var _ref = isEventType ? {
        eventType: eventTypeOrData,
        values: data
      } : {
        eventType: _index.eventState.data.type,
        values: eventTypeOrData
      },
      eventType = _ref.eventType,
      values = _ref.values;
    _index.eventState.addType(eventType);
    var template = (0, _index2.getWebInteractionTemplate)(eventType, values);
    _index.eventState.data.webInteraction = (0, _index5.mergeObjects)(template, _index.eventState.data.webInteraction);
    return this;
  },
  productListItems: function productListItems(productOrProducts) {
    var products = Array.isArray(productOrProducts) ? productOrProducts : [productOrProducts];
    products = products.filter(_isPlainObject2["default"]);
    products = products.map(_index2.getProductTemplate);
    _index.eventState.data.productListItems = _index.eventState.data.productListItems.concat(products);
    return this;
  },
  commerce: function commerce(eventTypeOrData, data) {
    var isEventType = typeof eventTypeOrData === 'string';
    var _ref2 = isEventType ? {
        eventType: eventTypeOrData,
        values: data
      } : {
        eventType: _index.eventState.data.type,
        values: eventTypeOrData
      },
      eventType = _ref2.eventType,
      values = _ref2.values;
    _index.eventState.addType(eventType);
    var template = (0, _index2.getCommerceTemplate)(eventType, values);
    _index.eventState.data.commerce = (0, _index5.mergeObjects)(template, _index.eventState.data.commerce);
    return this;
  },
  search: function search(eventTypeOrData, data) {
    var isEventType = typeof eventTypeOrData === 'string';
    var _ref3 = isEventType ? {
        eventType: eventTypeOrData,
        values: data
      } : {
        eventType: _index.eventState.data.type,
        values: eventTypeOrData
      },
      eventType = _ref3.eventType,
      values = _ref3.values;
    _index.eventState.addType(eventType);
    var template = (0, _index2.getSearchTemplate)(eventType, values);
    _index.eventState.data.search = template;
    return this;
  },
  media: function media(eventTypeOrData, data) {
    var isEventType = typeof eventTypeOrData === 'string';
    var _ref4 = isEventType ? {
        eventType: eventTypeOrData,
        values: data
      } : {
        eventType: _index.eventState.data.type,
        values: eventTypeOrData
      },
      eventType = _ref4.eventType,
      values = _ref4.values;
    _index.eventState.addType(eventType);
    var template = (0, _index2.getMediaTemplate)(eventType, values);
    _index.eventState.data.media = template;
    return this;
  },
  fire: function fire() {
    var event = _index.eventState.getEvent();
    var processedEvent = (0, _index3.executePipeline)(_index.eventState.data.eventTypes, event);
    var pushedEvent = (0, _index4.pushEventToDataLayer)(processedEvent);
    _index.eventState.reset(pushedEvent);
  },
  // TODO: remove preview method when is deprecated
  preview: function preview() {
    console.warn('alloyAnalytics: preview method will be deprecated in a next major release, no longer needed.');
    var event = _index.eventState.getEvent();
    var processedEvent = (0, _index3.executePipeline)(_index.eventState.data.eventTypes, event);
    var cleanedEvent = (0, _index5.removeEmptyKeys)(processedEvent);
    return cleanedEvent;
  },
  // TODO ends
  // TODO: remove reset method when is deprecated
  reset: function reset() {
    console.warn('alloyAnalytics: reset method will be deprecated in a next major release, no longer needed.');
    _index.eventState.reset();
  },
  // TODO ends
  applyCondition: function applyCondition(condition, method, event) {
    var supportedMethods = ['webInteraction', 'commerce', 'search', 'media'];
    if (!supportedMethods.includes(method)) {
      console.error("alloyAnalytics: ".concat(method, " is not a supported method for applyCondition."));
      return this;
    }
    if (condition) {
      var eventType = event.eventType,
        values = event.values;
      alloyAnalytics[method](eventType, values);
    }
    return this;
  },
  applyValues: function applyValues(_ref5) {
    var key = _ref5.key,
      base = _ref5.base,
      cases = _ref5.cases,
      fallback = _ref5.fallback;
    try {
      var initial = base || {};
      var values = cases[key] || fallback || {};
      return (0, _index5.mergeObjects)(values, initial);
    } catch (error) {
      var message = 'alloyAnalytics: an unexpected error ocurred while applying values and resolved to an empty object.';
      console.error(message, error);
      return {};
    }
  },
  applyFormatter: function applyFormatter(formatterName) {
    try {
      var _formatters$formatter;
      var formatters = _index.settingsState.formatters;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return (_formatters$formatter = formatters[formatterName]) === null || _formatters$formatter === void 0 ? void 0 : _formatters$formatter.call.apply(_formatters$formatter, [formatters].concat(args));
    } catch (error) {
      var message = "alloyAnalytics: an unexpected error occurred while executing ".concat(formatterName, " formatter and resolved to undefined.");
      console.error(message, error);
    }
  }
};
var _default = exports["default"] = alloyAnalytics;